import { useMemo, useState } from 'react';
import { CLIENT_TYPES } from '@/modules/clients/constants/client.constants';

export function useClientsFilters() {
  const [filters, setFilters] = useState({
    search: '',
    tipoCliente: CLIENT_TYPES.ALL,
  });

  const filterActions = useMemo(
    () => ({
      setSearch: (search) => setFilters((prev) => ({ ...prev, search })),
      setTipoCliente: (tipoCliente) => setFilters((prev) => ({ ...prev, tipoCliente })),
      reset: () => setFilters({ search: '', tipoCliente: CLIENT_TYPES.ALL }),
    }),
    []
  );

  return { filters, setFilters, ...filterActions };
}
